<template>
  <div id="app">
    <router-view />
  </div>
</template>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  text-align: center;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #7c2494;
}
/* Template Styles */

@import './assets/libs/bootstrap/dist/css/bootstrap.min.css';
@import './assets/css/style.min.css';
@import './assets/extra-libs/c3/c3.min.css';
@import './assets/extra-libs/jvector/jquery-jvectormap-2.0.2.css';
</style>

<script>
//import './staticFiles.js';

export default {
  name: '',
  components: {},
};
</script>
